import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getPublicFeatureFlagsV2Rpc } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getChirpEarlyRequest } from '../utils/earlyRequest';
import { isCountryCodeString } from '../utils/currencyTypes';
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const fetchPublicFeatureFlags = ({
  utk,
  browserLocale,
  preferredCountryCode
}) => {
  const request = {
    utk,
    browserLocale,
    preferredCountryCode: isCountryCodeString(preferredCountryCode) ? preferredCountryCode : undefined
  };
  return getChirpEarlyRequest({
    details: Object.assign({}, getPublicFeatureFlagsV2Rpc, {
      earlyRequest: true
    }),
    requestObject: {
      request
    },
    fallbackFetcher: () => rpcClientNoAuth.call(getPublicFeatureFlagsV2Rpc, {
      request
    })
  }).catch(() => ({
    activeFeatureFlags: []
  }));
};
export const GET_PUBLIC_FEATURE_FLAGS = registerQuery({
  fieldName: 'featureFlags',
  args: ['utk', 'browserLocale', 'preferredCountryCode'],
  fetcher: fetchPublicFeatureFlags
});